import React, { useReducer, useEffect } from "react";

import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import { User } from "./User";
import { cUserApi } from "./UserApi";
import { cPermissionApi } from "./PermissionsApi";
import { cPageStyles } from "./PageStyles";
import { cLoginInitialState, cLoginReducer } from "./LoginAction";
import { cUserManager } from "./UserManager";
//state type

interface LoginProps {
  //loggedIn: boolean;
  loginHandler: () => void;
  //changePassword: boolean;
  changePasswordHandler: () => void;
  loginStateHandler: () => void;
}
const Login: React.FC<LoginProps> = ({
  //loggedIn,
  loginHandler,
  //changePassword,
  changePasswordHandler,
  loginStateHandler,
}: LoginProps) => {
  const classes = cPageStyles(); // WORKS (WITH CHANGE PSD TOO)
  const [state, dispatch] = useReducer(cLoginReducer, cLoginInitialState);

  /*
   *** MAKE USER OBJECT ... DONE
   */
  const user = new User();
  useEffect(() => {
    if (state.username.trim() && state.password.trim()) {
      dispatch({
        type: "setIsButtonDisabled",
        payload: false,
      });
    } else {
      dispatch({
        type: "setIsButtonDisabled",
        payload: true,
      });
    }
  }, [state.username, state.password]);

  useEffect(() => {
    if (window.setTimeout(() => {}, 50000)) {
      dispatch({
        type: "setTimeOut",
        payload: true,
      });
    }
  }, [state.timeOut]);
///
  const getUserData = async (email: string) => {
    await cUserApi.initUserApi();
    const apiResult = await cUserApi.getUserWithEmail(email);
    return apiResult;
  };

  /* 
    Is called when login button is pressed
    Matches the user credentials
    Stores current user details in the UserManager
    Sets permissions for the current user
    LOGIC: The user table data is loaded and user email and password are compared to db enteries
           IF the credentials match, the user is logged in, user info is saved into a UserManager
           That handles all of the current user operations AND user permissions are granted
    Problem: All of the table loaded from database, need to convert it to a query with a WHERE Clause 
  */
  const handleLogin = async () => {
    dispatch({
      type: "setIsButtonDisabled",
      payload: true,
    });

    console.time("Login: ");
 
    var okay = false;
    const userData = await getUserData(state.username); // Get all the Users (Optimize with WHERE query)
    while (userData.next()) {
      const currUserMap: Map<string, any> = new Map();
      currUserMap.set("Email", userData.getProperty("Email"));
      currUserMap.set("Password", userData.getProperty("Password"));
      currUserMap.set("FirstName", userData.getProperty("FirstName"));
      currUserMap.set("LastName", userData.getProperty("LastName"));
      currUserMap.set("Organization", userData.getProperty("Organization"));
      currUserMap.set("Role", userData.getProperty("Role"));
      // Decrypts the password and matches it
      const pass = await cUserApi.decryptPassword(currUserMap.get("Password"));
      console.log(pass);
      if (
        currUserMap.get("Email") === state.username &&
        pass === state.password
      ) {
        dispatch({
          type: "loginSuccess",
          payload: "Login Successfully",
        });
        okay = true;
        // Initializes User
        user.initialize(
          currUserMap.get("FirstName"),
          currUserMap.get("LastName"),
          currUserMap.get("Email"),
          currUserMap.get("Role"),
          [""],
          currUserMap.get("Organization"),
        );

        console.timeEnd("Login: ");

        cPermissionApi.initPermissionApi();
        const permissions = await cPermissionApi.getPermissions(); // Sets the permission based on org role
        while (permissions.next()) {
          const currPermissionName = permissions.getProperty("Name");
          const currPermissions = permissions.getProperty("Permissions");
          if (currPermissionName === currUserMap.get("Role")) {
            user.permissions = currPermissions;
          }
        }
        // IMP
        cUserManager.setProperty(user);
        loginStateHandler(); // Callback function that manages Login. Sets LoggedIn flag to true
                             // indicating the user has loggedin
        return;
      }
    }
    if (!okay) {
      dispatch({
        type: "setIsButtonDisabled",
        payload: false,
      });
      dispatch({
        type: "loginFailed",
        payload: "Incorrect username or password",
      });
      console.log("NOT OKAY");
    } else if (state.timeOut) {
      dispatch({
        type: "setIsButtonDisabled",
        payload: false,
      });
      dispatch({
        type: "loginFailed",
        payload: "Network issue time out. Please Retry",
      });
    }
  };
  const handlePasswordChangeBtn = () => {
    changePasswordHandler();
    loginHandler();
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.keyCode === 13 || event.which === 13) {
      state.isButtonDisabled || handleLogin();
    }
  };

  const handleUsernameChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    dispatch({
      type: "setUsername",
      payload: event.target.value,
    });
  };

  const handlePasswordChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    dispatch({
      type: "setPassword",
      payload: event.target.value,
    });
  };
  return (
    <form className={classes.container} noValidate autoComplete="off">
      <Card className={classes.card} style={{ width: "500px" }}>
        <header className={classes.header}>
          <img src={"/image/Geminai_logo.png"} alt="" className={classes.img} />
        </header>
        <CardContent>
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={"/image/user.png"}
                style={{ marginTop: "20px", height: "23px" }}
              ></img>

              <TextField
                className={classes.input}
                style={{ marginLeft: "3px" }}
                error={state.isError}
                fullWidth
                id="username"
                type="email"
                label="Email"
                placeholder="Email"
                margin="normal"
                onChange={handleUsernameChange}
                onKeyPress={handleKeyPress}
              />
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={"/image/key.png"}
                style={{ marginTop: "20px", height: "20px" }}
              ></img>
              <TextField
                style={{ marginLeft: "5px" }}
                error={state.isError}
                fullWidth
                id="password"
                type="password"
                label="Password"
                placeholder="Password"
                margin="normal"
                helperText={state.helperText}
                onChange={handlePasswordChange}
                onKeyPress={handleKeyPress}
              />
            </div>
            <Button
              variant="contained"
              size="small"
              color="primary"
              style={{
                marginLeft: "15px",
                marginTop: "15px",
                fontSize: "11px",
                color: "#2862E2",
                outline: "0",
                boxShadow: "0px 0px 0px",
              }}
              className={classes.changePsdBtn}
              onClick={handlePasswordChangeBtn}
              disabled={false}
            >
              Change Password
            </Button>
          </div>
        </CardContent>

        <CardActions>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            className={classes.loginBtn}
            onClick={handleLogin}
            disabled={false}
          >
            Login
          </Button>
        </CardActions>
      </Card>
    </form>
  );
};

export default Login;
